<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Business Unit Warehouse Management
          </div>

          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="Inventory" name="inventory">
              <inventory ref="inventory"/>
            </el-tab-pane>
            <el-tab-pane label="Stock Requisitions" name="stockRequisitions" disabled>Stock Requisitions</el-tab-pane>
            <el-tab-pane label="Inventory Transfers" name="inventoryTransfers" disabled>Inventory Transfers</el-tab-pane>
            <el-tab-pane label="Stock Counts" name="stockCounts" disabled>Stock Counts</el-tab-pane>
            <el-tab-pane label="Quantity Adjustments" name="quantityAdjustments" disabled>Quantity Adjustments</el-tab-pane>
            <el-tab-pane label="Warehouse Items Worksheet" name="warehouseItemsWorksheet" disabled>Warehouse Items Worksheet</el-tab-pane>
          </el-tabs>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Inventory from '@/components/BUWarehouseManagement/Inventory'
  import WarehouseItemsReport from '@/components/warehousing/WarehouseItemsReport'

  export default {
    name: 'bu-warehouse-management',
    components: {
      WarehouseItemsReport,
      Inventory
    },
    data() {
      return {
        activeName: 'inventory',
      }
    },
    mounted() {
      this.$refs['inventory'].openTab()
    },
    methods: {
      handleClick(tab, event) {
        this.$refs[tab.name].openTab()
      },
    }
  }
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
